// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeAboutCommittedBuyersPage_wrapper__vJ-WG"};